import { computed, defineComponent, ref } from 'vue';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { ProcureGetter } from '@/store/procure/procure.module';
import { Procure, ProjectEndDate } from '@/store/procure/procure.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ProjectProcureAttachmentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  props: {
    projectId: {
      type: Number
    }
  },
  setup: () => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const procure = computed<Procure>(() => store.getters[ProcureGetter.GET]);
    const endDates = computed<ProjectEndDate[]>(() => procure.value?.endDates);
    const endDateOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();

    // show modal
    const show = () => {
      endDateOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      endDateOffcanvas.value?.hide();
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'long');

    return {
      endDates,
      endDateOffcanvas,
      show,
      hide,
      thaiDate,
    };
  }
});
